import config from 'config';
import { CallUs } from '$components/basic/CallUs';
import VrmLookup from '$quantum/molecules/VrmLookup';
import { Title } from '@/components/atoms/Title';
import { Container } from './styled';

export default function WidgetEditor(): JSX.Element {
  return (
    <Container className="WidgetEditor">
      <Title>Book hassle-free repair</Title>
      <VrmLookup
        formAction="/vehicles/add"
        extraParams={{
          itm_widget: 'sidebarStartBooking',
          itm_article: 'none',
          itm_wo: 'none',
        }}
        targetBlank
        buttonText={<>Get an instant quote</>}
      />
      <CallUs phoneNumber={config.get('public.phone_number') || '0330 808 9527'} />
    </Container>
  );
}
